import { EVENTS, FETCH_USER, LOGIN_BASE, PHOTOGRAPHS } from "../../helpers/constants/url";
import baseApi from "./baseApiEndpoints";

// Define a service using a base URL and expected endpoints
export const eventsApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getAllEvents: builder.query({
      query: () => `${EVENTS}`,
      providesTags: ["Event"],
    }),
    getEventsById: builder.query({
        query: (id) => `${EVENTS}${id}/`,
        providesTags: ["Event"],
    }),
    getPhotosByEvent: builder.query({
      query: (id) => `${EVENTS}${id}/photos/`,
      providesTags: ["Photo"],
    }),
    uploadEventPhoto: builder.mutation(
      {
        query: (payload) => ({
          url: `${PHOTOGRAPHS}`,
          method: "POST",
          body: payload,
        }),
        invalidatesTags: ["Photo"]
      }
    ),
    createEvent: builder.mutation({
      query: (event) => ({
        url: `${EVENTS}`,
        method: "POST",
        body: event,
      }),
      invalidatesTags: ["Event"]
    }),
    eventUpdate: builder.mutation({
      query: (payload) => ({
        url: `${EVENTS}${payload.get("id")}/`,
        method: "PATCH",
        body: payload,
      }),
      invalidatesTags: ["Event"]
    }),
    photoRemove: builder.mutation({
      query: (ids) => ({
        url: `${PHOTOGRAPHS}${ids}/`,
        method: "DELETE",
      }),
      invalidatesTags: ["Photo"]
    }),
  }),
  overrideExisting: false,
});

export const { useGetAllEventsQuery, useGetEventsByIdQuery, useGetPhotosByEventQuery, useUploadEventPhotoMutation, useCreateEventMutation, useEventUpdateMutation, usePhotoRemoveMutation } = eventsApi;
